import { ODD_EVEN } from './event';
export var StatusFetch;
(function (StatusFetch) {
    StatusFetch["IDLE"] = "idle";
    StatusFetch["LOADING"] = "loading";
    StatusFetch["ERROR"] = "error";
    StatusFetch["SUCCESS"] = "success";
})(StatusFetch || (StatusFetch = {}));
export var FontFamilyType;
(function (FontFamilyType) {
    FontFamilyType["REGULAR"] = "BaiJamjuree";
    FontFamilyType["MEDIUM"] = "BaiJamjuree-Medium";
    FontFamilyType["SEMIBOLD"] = "BaiJamjuree-SemiBold";
    FontFamilyType["BOLD"] = "BaiJamjuree-Bold";
    FontFamilyType["BOLD_ITALIC"] = "BaiJamjuree-BoldItalic";
})(FontFamilyType || (FontFamilyType = {}));
export var TeamType;
(function (TeamType) {
    TeamType["HOME"] = "home";
    TeamType["AWAY"] = "away";
})(TeamType || (TeamType = {}));
export const CURRENCY = {
    VND: 'VND',
    USD: 'USD',
    USDT: 'USDT',
    THB: 'THB',
};
export var ThemeColor;
(function (ThemeColor) {
    ThemeColor["Blue"] = "blue";
    ThemeColor["Red"] = "red";
    ThemeColor["Green"] = "green";
    ThemeColor["Gold"] = "gold";
    ThemeColor["LightGreen"] = "light-green";
})(ThemeColor || (ThemeColor = {}));
export var ThemeId;
(function (ThemeId) {
    ThemeId[ThemeId["Theme1"] = 1] = "Theme1";
    ThemeId[ThemeId["Theme2"] = 2] = "Theme2";
    ThemeId[ThemeId["Theme3"] = 3] = "Theme3";
    ThemeId[ThemeId["Theme4"] = 4] = "Theme4";
    ThemeId[ThemeId["Theme5"] = 5] = "Theme5";
    ThemeId[ThemeId["Theme6"] = 6] = "Theme6";
    ThemeId[ThemeId["Theme7"] = 7] = "Theme7";
    ThemeId[ThemeId["Theme8"] = 8] = "Theme8";
    ThemeId[ThemeId["Theme9"] = 9] = "Theme9";
    ThemeId[ThemeId["Theme10"] = 10] = "Theme10";
    ThemeId[ThemeId["Theme11"] = 11] = "Theme11";
    ThemeId[ThemeId["Theme12"] = 12] = "Theme12";
    ThemeId[ThemeId["Theme13"] = 13] = "Theme13";
})(ThemeId || (ThemeId = {}));
export var FontSizeCountdownText;
(function (FontSizeCountdownText) {
    FontSizeCountdownText[FontSizeCountdownText["Under1Minute"] = 15] = "Under1Minute";
    FontSizeCountdownText[FontSizeCountdownText["Over1Minute"] = 12] = "Over1Minute";
    FontSizeCountdownText[FontSizeCountdownText["Under1MinuteDesktop"] = 40] = "Under1MinuteDesktop";
    FontSizeCountdownText[FontSizeCountdownText["Over1MinuteDesktop"] = 30] = "Over1MinuteDesktop";
})(FontSizeCountdownText || (FontSizeCountdownText = {}));
export var FontSizeCountdownMiniVersionText;
(function (FontSizeCountdownMiniVersionText) {
    FontSizeCountdownMiniVersionText[FontSizeCountdownMiniVersionText["Under1Minute"] = 20] = "Under1Minute";
    FontSizeCountdownMiniVersionText[FontSizeCountdownMiniVersionText["Over1Minute"] = 15] = "Over1Minute";
})(FontSizeCountdownMiniVersionText || (FontSizeCountdownMiniVersionText = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Mobile"] = "mobile";
    DeviceType["Desktop"] = "desktop";
})(DeviceType || (DeviceType = {}));
export var ElementId;
(function (ElementId) {
    ElementId["ScrollChip"] = "scroll-chip";
})(ElementId || (ElementId = {}));
export var MoneyThousand;
(function (MoneyThousand) {
    MoneyThousand[MoneyThousand["K"] = 1000] = "K";
    MoneyThousand[MoneyThousand["M"] = 1000000] = "M";
})(MoneyThousand || (MoneyThousand = {}));
export var FieldQueryStringUrl;
(function (FieldQueryStringUrl) {
    FieldQueryStringUrl["agentId"] = "agentId";
    FieldQueryStringUrl["token"] = "token";
})(FieldQueryStringUrl || (FieldQueryStringUrl = {}));
export const MONEY_THOUSAND = 1000;
export const MONEY_MILLIONS = 1000000;
export const convertOdds = (odds = '') => {
    const oddArr = (!!odds && odds.split(' ')) || [];
    const homeWinOdd = (!!oddArr[ODD_EVEN.ODD_ODD] && oddArr[ODD_EVEN.ODD_ODD].split('*')[0]) || '';
    const homeSelectionId = (!!oddArr[ODD_EVEN.ODD_ODD] && oddArr[ODD_EVEN.ODD_ODD].split('*')[1]) || '';
    (!!oddArr[ODD_EVEN.ODD_ODD] && oddArr[ODD_EVEN.ODD_ODD].split('*')[1]) || '';
    const awayWinOdd = (!!oddArr[ODD_EVEN.ODD_EVEN] && oddArr[ODD_EVEN.ODD_EVEN].split('*')[0]) || '';
    const awaySelectionId = (!!oddArr[ODD_EVEN.ODD_EVEN] && oddArr[ODD_EVEN.ODD_EVEN].split('*')[1]) || '';
    const offerId = oddArr[ODD_EVEN.OFFER_ID];
    return {
        homeWinOdd,
        homeSelectionId,
        awayWinOdd,
        awaySelectionId,
        offerId,
    };
};
